"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FormFieldTooltip = void 0;
const react_1 = __importDefault(require("react"));
const classFunctions_1 = require("../../../../utils/classFunctions");
const flatArray_1 = require("../../../../utils/flatArray");
require("./index.scss");
const className = 'form-field-tooltip';
const FormFieldTooltip = (props) => {
    var _a, _b;
    const { info, error } = props;
    const infos = (_a = (0, flatArray_1.flatArray)(info)) === null || _a === void 0 ? void 0 : _a.map((element) => ({
        element,
    }));
    const errors = (_b = (0, flatArray_1.flatArray)(error)) === null || _b === void 0 ? void 0 : _b.map((element) => ({
        element,
        modificators: 'error',
    }));
    const items = (0, flatArray_1.flatArray)([infos, errors]);
    if (!items)
        return null;
    return (react_1.default.createElement("div", { className: className }, items === null || items === void 0 ? void 0 : items.map((item, index) => (react_1.default.createElement("div", { key: index, className: (0, classFunctions_1.getClassNames)(`${className}__note`, item.modificators) }, item.element)))));
};
exports.FormFieldTooltip = FormFieldTooltip;
//# sourceMappingURL=index.js.map